import { Grid } from '@material-ui/core';
import React from 'react';
import { MandatoryField, SecondaryButton } from '../../../../../Core/Controls';
import { VehicleInspections_ReturnToTech } from '../../../../../Core/Services/InternalUser/Vehicle/vehicleTabChecks';
import { useToast } from '../../../../../Core/Hooks/useToast';

const ReturnToEngineer = ({ vehicleInspectionID, onClose }) => {
    const { showToastWarning, showToastError, showToastSuccess } = useToast();

    const [state, setState] = React.useState({
        comment: '',
        errors: {}
    });
    const [btnLoader, setBtnLoader] = React.useState(false);

    const handleInput = (event) => {
        const { name, value } = event.target;
        setState((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const validations = () => {
        const { comment } = state;
        let formIsValid = true;
        let errors = {};

        if (!comment.trim()) {
            errors.comment = 'This field is required.';
            formIsValid = false;
        }

        setState((prevState) => ({
            ...prevState,
            errors
        }));

        return formIsValid;
    };

    const handleSubmit = async () => {
        if (!validations()) return;

        const data = {
            comment: state.comment.trim(),
            vehicleInspectionID
        };

        try {
            setBtnLoader(true);
            const res = await VehicleInspections_ReturnToTech(data);
            if (res.success) {
                showToastSuccess('Returned to engineer successfully');
                onClose?.(true);
            } else {
                showToastError(res.message || 'Something went wrong');
            }
        } catch (err) {
            console.error(err);
            showToastError('Failed to return to engineer');
        } finally {
            setBtnLoader(false);
        }
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} className="mandatory-fields">
                <MandatoryField
                    autoFocus={true}
                    inputLabel="Notes"
                    placeholder="Enter reason for return"
                    name="comment"
                    value={state.comment}
                    onChange={handleInput}
                    multiline
                    rows={5}
                    errors={state.errors?.comment}
                />
            </Grid>
            <Grid item xs={12}>
                <SecondaryButton isBtnLoader={btnLoader} onClick={handleSubmit}>Return To Engineer</SecondaryButton>
            </Grid>
        </Grid>
    );
};

export default ReturnToEngineer;
